import { Source } from 'react-native-fast-image';
import { registerImages } from '@betty/moonlight';

import cashOrBonus from './cash-or-bonus.webp';
import bettyPromoCoins from './betty-promo-coins.webp';
import bettyPromoWheel from './betty-promo-wheel.webp';
import fallBackBannerMini from './fallback-banner-mini.webp';

import icons from './icons';

const images = {
  ...icons,

  cashOrBonus,
  bettyPromoCoins,
  bettyPromoWheel,
  fallBackBannerMini,
};

registerImages('promos', images);

declare global {
  interface RegisteredImages {
    promos: Record<keyof typeof images, Source>;
  }
}
